import { BackendEnvironment, FrontendEnvironment } from '@ahd/shared/types/misc/environments';
import { ahdFleetBackendUrl, ahdFleetFrontendUrl } from '@ahd/shared/vars/ahd-fleet/urls';
import { ahdWebBackendUrl, ahdWebFrontendUrl } from '@ahd/shared/vars/ahd-web/urls';

import { type ConfigObject, DebugLevel } from './_configs/types';
import { ViewOptionsView } from './hooks/use-car-search/types';
import { type Modules } from './modules/_definition/types';

import type { FleetLocalStorageSettings, FleetSessionStorageSettings } from './types';

export const APPLICATION_NAME = process.env.REACT_APP_APPLICATION_NAME;
export const PORT = process.env.REACT_APP_PORT;
export const SERVLETPORT = process.env.REACT_APP_SERVLETPORT;
export const SERVLETPORT_WEBSERVLETS = process.env.REACT_APP_SERVLETPORT_WEBSERVLETS;

export const ENVIRONMENT =
    process.env.REACT_APP_LOCALSERVER === 'true'
        ? BackendEnvironment.LOCALSERVER
        : process.env.REACT_APP_DEV === 'true'
          ? BackendEnvironment.DEV
          : process.env.REACT_APP_NEXT === 'true'
            ? BackendEnvironment.NEXT
            : BackendEnvironment.LIVE;
export const ENVIRONMENT_FRONTEND =
    process.env.REACT_APP_LOCALSERVER === 'true'
        ? FrontendEnvironment.LOCALSERVER
        : process.env.REACT_APP_DEV === 'true'
          ? FrontendEnvironment.DEV
          : process.env.REACT_APP_NEXT === 'true'
            ? FrontendEnvironment.NEXT
            : process.env.REACT_APP_PRE_RELEASE === 'true'
              ? FrontendEnvironment['PRE-PRELEASE']
              : process.env.REACT_APP_TEST === 'true'
                ? FrontendEnvironment.TEST
                : FrontendEnvironment.LIVE;

export const srUrl = ahdWebBackendUrl(ENVIRONMENT_FRONTEND === FrontendEnvironment.LOCALSERVER ? BackendEnvironment.NEXT : ENVIRONMENT, SERVLETPORT_WEBSERVLETS);
export const srFrontendUrl = ahdWebFrontendUrl(ENVIRONMENT_FRONTEND === FrontendEnvironment.LOCALSERVER ? FrontendEnvironment.NEXT : ENVIRONMENT_FRONTEND, SERVLETPORT_WEBSERVLETS);
export const sUrl = ahdFleetBackendUrl(ENVIRONMENT_FRONTEND === FrontendEnvironment.LOCALSERVER ? BackendEnvironment.NEXT : ENVIRONMENT, SERVLETPORT);
export const baseUrl = ahdFleetFrontendUrl(ENVIRONMENT_FRONTEND === FrontendEnvironment.LOCALSERVER ? FrontendEnvironment.LOCALSERVER : ENVIRONMENT_FRONTEND, PORT);

/** Necessary Cookie */
export const LOCAL_STORAGE_LANG = 'i18nextLng';
/** Necessary Cookie */
export const LOCAL_STORAGE_SETTINGS = 'hpt:storage';
/** Marketing Cookie */
export const COOKIE_UTM = 'sr:utm';

export const defaultLocalStorage: FleetLocalStorageSettings = { allowMaps: false, auth: null, listMode: ViewOptionsView.Grid };
export const defaultSessionStorage: FleetSessionStorageSettings = { debug: DebugLevel.NONE, historyBack: null, lastViewedCar: null, originalH1: undefined, search: null };

export interface ModuleSkeletonProps {
    module?: Modules;
    rootContainer: HTMLDivElement;
    settings: ConfigObject;
}

export interface MetaData {
    canonical: string;
    desc: string;
    image: string;
    imageAlt: string;
    tags: string;
    title: string;
    titleRaw: string;
    url: string;
}
